export const TEXTS = {
  NOTIFICATION_DEFAULT_INFO_MESSAGE: 'Операция выполнена',
  NOTIFICATION_DEFAULT_SUCCESS_MESSAGE: 'Операция успешно выполнена',
  NOTIFICATION_DEFAULT_WARNING_MESSAGE: 'Операция выполнена с замечаниями',
  NOTIFICATION_DEFAULT_ERROR_MESSAGE: 'Произошла непредвиденная ошибка',
};
